import React from 'react';
import { func, bool } from 'prop-types';
import { getStudyTargets } from '../../../actions/deActions/deImportDefActions';
import { CROSSTAB_FEATUREID } from '../../../constants';
import { saveTrackingData } from '../../../util/trackerUtils';

import Autocode from '../../autocode/Autocode';
import AutocodeRunButton from '../../autocode/AutocodeRunButton';
import { useSelector, useDispatch } from '../../common/react-redux-hooks';
import DEBreadcrumb from '../shared/DEBreadcrumb';
import PreviewSection from './PreviewSection';
import * as deBuildActions from '../../../actions/deActions/deBuildActions';
import { DATAHUB_SAMPLE_WARN_COUNT } from '../../../actions/urlTypes';
import DeDialog from '../shared/DeDialog';
import DeleteConfirmModalContent from './DeleteConfirmModalContent';
import UnsavedBuildContent from './UnsavedBuildContent';
import { DATAHUB_BUILD_MODULE } from '../shared/DEConstants';

const BuildView = ({
  routerLeaveModal,
  resetRouterLocation,
  confirmNavigation,
}) => {
  const { studies = {}, userId, currentAccountId, 
  datahubWeightTypes, activeAccountId, deBuildTargets,
  unsavedSelectionBox, tempTarget, isEditTarget,impersonated } = useSelector(state => ({
    studies: state.deImportDefiniton.studies,
    userId: state.login.loginResponse.data.userId,
    currentAccountId: state.login.loginResponse.data.currentAccountId,
    datahubWeightTypes: state.study.datahubWeightTypes,
    activeAccountId: state.account.activeAccountId,
    deBuildTargets: state.deBuild.deBuildTargets,
    unsavedSelectionBox: state.deBuild.unsavedSelectionBox,
    tempTarget: state.deBuild.tempTarget,
    isEditTarget: state.deBuild.isEditTarget,
    impersonated:state.login.loginResponse.data.impersonated
  }))

  const [isDeleteModal, setDeleteModalView] = React.useState(false);

  const dispatch = useDispatch();

  const handleStudyChange = (val) => {
    dispatch(getStudyTargets(val))
  }

  const _toggleDeleteConfirmModal = () => {
    setDeleteModalView(!isDeleteModal)
  }

  const _removeAllTargets = () => {
    dispatch(deBuildActions.removeTargets())
    setDeleteModalView(false)
  }

  const confirmNavigationModal = () => {
    dispatch(deBuildActions.removeTargets())
    confirmNavigation()
  }

  const callSaveTrackerFn = ({ action, attributes = undefined }) => {
    const productNo =
      studies.activeStudy !== undefined
        ? studies.activeStudy.pn
        : undefined;
    saveTrackingData({
      uid: userId,
      accid: currentAccountId,
      productNo,
      moduleName: DATAHUB_BUILD_MODULE,
      attributes,
      action,
    });
  };

  return (
    <div className="de--main de--target de--flex-col de-o-hidden de--build">
      <Autocode
        studies={studies.data}
        featureID={CROSSTAB_FEATUREID}
        defaultStudy={studies.activeStudy}
        alertMsg="This selection will impact all of the Datahub modules"
        showWeightType
        selectedWeightType={datahubWeightTypes}
        menuName={DATAHUB_BUILD_MODULE}
        handleStudyChange={handleStudyChange}
        // runReport={props.runAfterWeightChange}
        uid={userId}
        trackerFn={callSaveTrackerFn}
        moduleAction={deBuildActions}
        showTargetBtn
        rightSideClass="autocode-right-col-de"
        sampleLimit={DATAHUB_SAMPLE_WARN_COUNT}
        sampleNCSLimit={DATAHUB_SAMPLE_WARN_COUNT}
        showSmplWghtDisplay
        isSelectionBoxEmptyFlag
      >
        <DEBreadcrumb
          parent="DataHub / "
          child="Activate Campaign Targets"
        />
        <PreviewSection removeAllTargets={_toggleDeleteConfirmModal} />
        <AutocodeRunButton
          title="Save to Target List"
          isRunEnabled={deBuildTargets.length > 0 && !impersonated}
          autocodeRun={() => {
            dispatch(deBuildActions.saveAutocodeTargetList(activeAccountId,false, deBuildTargets)
            );
          }}
          btnClass='autocode-runbutton-de'
          handleDisableClass
        />
        {/**
         * As mentioned in PLAT-10959, contents of the autocode selection box has to be removed
         * when Clear Targets button is clicked in Save changes popup. To clear selection box contents,
         * access to Autocode Context is needed, so this below popup component has to be placed here. 
         */}
        {routerLeaveModal && (deBuildTargets.length > 0 || unsavedSelectionBox || tempTarget !== null) &&
          <DeDialog
            className="de__unsaved--modal"
            open={routerLeaveModal}
            title="Unsaved Targets"
            id="dialog-unsaved-build"
          >
            <UnsavedBuildContent
              confirmNavigation={confirmNavigationModal}
              resetRouterLocation={resetRouterLocation}
              routerLeaveModal={routerLeaveModal}
            />
          </DeDialog>
        }
      </Autocode>
      {isDeleteModal && (
        <DeDialog
          className="de--build-delete-modal"
          open={isDeleteModal}
          onClose={_toggleDeleteConfirmModal}
          title="Delete"
          id="dialog-delete"
        >
          <DeleteConfirmModalContent
            handleClose={_toggleDeleteConfirmModal}
            handleDelete={_removeAllTargets}
          />
        </DeDialog>
      )}
      {isEditTarget && <div className = "de--build--overlay" />}
    </div>
  );
};

BuildView.propTypes = {
  resetRouterLocation: func,
  routerLeaveModal: bool,
  confirmNavigation: func,
};

export default BuildView;
